import { render, staticRenderFns } from "./DropdownLang.vue?vue&type=template&id=767b03b6"
import script from "./DropdownLang.vue?vue&type=script&lang=js"
export * from "./DropdownLang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports